import { useGetReviewerPermissions } from '@exam-center/admin-exam-location-management';
import {
  AdminExamLocationRequestList,
  AdminExamLocationRequestListNavigationTabs,
  AdminExamLocationRequestListFilterSection,
} from '@exam-center/admin-exam-location-request-list';
import { ExamLocationRequestSupervisorStatusSummary } from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PaperSection, Flex, Divider } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamLocationRequestListPage() {
  const { view } = useGetReviewerPermissions();
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW
          .VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <PaperSection title='รายการยื่นคำขออนุมัติสถานที่สอบ'>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(6),
            p: theme.spacing(6),
          })}
        >
          {view.supervisor ? <ExamLocationRequestSupervisorStatusSummary /> : null}
          <AdminExamLocationRequestListFilterSection />
          <Flex
            sx={(theme) => ({
              borderRadius: theme.shape.rounded(2),
              border: '1px solid',
              borderColor: theme.palette.grey[200],
              flexDirection: 'column',
              overflow: 'hidden',
              flexGrow: 1,
            })}
          >
            <Flex
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(2),
                border: '1px solid',
                borderColor: theme.palette.grey[200],
                flexDirection: 'column',
                overflow: 'hidden',
                flexGrow: 1,
              })}
            >
              <AdminExamLocationRequestListNavigationTabs />
              <Divider
                sx={{
                  mt: '-1px',
                }}
              />
              <AdminExamLocationRequestList />
            </Flex>
          </Flex>
        </Flex>
      </PaperSection>
    </PermissionGuard>
  );
}
